<template>
	<div class='route_container'>
		<!-- Email verification Notify -->
		<notification-form v-if="!$store.state.email"></notification-form>  
		<!-- Hero section -->				
		<div v-if="$store.state.meta.main_giveaway" class="bg-gradient py-5 px-5 mt-5 hero_section">
			<a v-if="!loading" :href="`https://${$store.state.meta.lang}.idcgames.com/${$store.state.meta.main_giveaway.game_seo}`" class="hero_section__img_link big-card" target="_blank">
				<div v-if="$store.state.meta.main_giveaway" class="img-container">
					<div class="col overflow-hidden px-0">
						<div class="overlay">
							<img :src="$store.state.meta.main_giveaway.game_logo" class="logo-overlay card-img-overlay d-flex align-items-center img-fluid m-auto" alt="--">
						</div>
						<div class="overflow-hidden logo-img-container">
							<img class="gameCard-img" :src="$store.state.meta.main_giveaway.game_banner" alt="...">
						</div>
					</div>
				</div>
			</a>
			<a v-else class="hero_section__img_link big-card">
				<div class="img-container-init">					
				</div>
			</a>			
			<div class="hero_section__summary py-3 px-3">
				<div class='col-12' key='loading' v-if="loading">
					<thread-display-placeholder></thread-display-placeholder>
				</div>
				<div class="col-12" v-else>
					<h2 class="mb-2">
						<router-link :to="`/${$store.state.meta.lang}/giveaway/${$store.state.meta.main_giveaway.creator}/${$store.state.meta.main_giveaway.game_seo}/${$store.state.meta.main_giveaway.giveaway_id}`">
							{{$store.state.meta.main_giveaway.game_name}}
						</router-link> 
						({{ $store.state.meta.main_giveaway.point || 0 }} p) 
					</h2>
					<div class="summary_columns">
						<div class="summary__column">
							<info-tooltip>
								<template slot='content'>
									<span><font-awesome-icon class="info_icon" :icon="['fa','clock']" /> 
										{{ $store.state.meta.main_giveaway.end_date | localTime }}
									</span>
								</template>
								
								<div slot='display' class="d-flex justify-content-center align-items-center">
									<font-awesome-icon :icon='["fa","clock"]' class="mr-1"/> 
									{{ $store.state.meta.main_giveaway.end_date | localTime | formatDate(1)}} {{ $t('gifts_remaining') }} 
								</div>
							</info-tooltip>
						</div>
						<div class="summary__column text-right">
							<info-tooltip class="d-inline-flex">
								<template slot='content'>
									<span>
										<font-awesome-icon class="info_icon" :icon="['fa','clock']" />
										{{$store.state.meta.main_giveaway && $store.state.meta.main_giveaway.start_date | localTime}}
									</span>
								</template>
								<div
									slot='display'
								> 
									{{$store.state.meta.main_giveaway.start_date | localTime | formatDate}} {{ $t('gifts_ago') }} 
								</div>								
							</info-tooltip>	
							<span class="mx-1">{{ $t('gifts_by') }}</span>						
							<router-link :to="`/${$store.state.meta.lang}/user/${$store.state.meta.main_giveaway.creator}`"> 
								{{ $store.state.meta.main_giveaway && $store.state.meta.main_giveaway.creator }}
							</router-link>							
						</div>
						<router-link 
							:to="`/${$store.state.meta.lang}/user/${$store.state.meta.main_giveaway.creator}`" 
							class="giveaway_image_avatar" 							
							:style="$store.state.meta.main_giveaway.profile_photo_path ? 
									{ 'background-image': 'url(' + apiDomain + '/uploads/avatar/' + $store.state.meta.main_giveaway.profile_photo_path + ')' }:
									{ 'background-image': 'url(' + missed_avatar + ')' }"
						>
						</router-link>
					</div>
				</div>
				
			</div>
		</div>
		<div class="main_container px-5 py-5">
			<div class="row">
				<!-- category sidebar -->
				<div class="col-lg-3 filter-column pr-lg-3 px-0 py-3">
					<fancy-input
						:placeholder='`${ $t("gifts_search") }...`'
						v-model='searchGiveaway'
						type="text"
						aria-label="Search"
						ref="search"
						:large='true'
						:error='errors.search'
					></fancy-input>
					<ul id="filtersList" class="nav accordion d-flex flex-column flex-nowrap bg-gray-900 border border-green-lighter border-top-0  box-shadow my-3">
						<li class="nav-item py-3">
							<div class="d-flex row align-items-center justify-content-between m-0 px-2">
								<div class="categories-title d-flex row align-items-center col-11">
									<p class="h6 text-white mb-0 py-2">{{ $t('gifts_browse') }}</p>
								</div>
							</div>
							<router-link
								v-for='(category, $index) in categories'
								:key='"category-link-" + $index'
								class='threads_main__side_bar__menu_item'
								:to='`/${$store.state.meta.lang}/landing?type=` + category.value'
							>
								<span
									class='threads_main__side_bar__menu_item__border'
								></span>
								<span
									class='threads_main__side_bar__menu_item__text'
								>{{category.name}}</span>
							</router-link>							
						</li>
					</ul>
				</div>
				<div class='col-lg-9 pl-lg-3 px-0 pb-3' key='loading' v-if="loading">
					<thread-display-placeholder></thread-display-placeholder>
				</div>
				<div class="col-lg-9 pl-lg-3 px-0 pb-3" v-else>
					<!-- pinned giveway list -->
					<div class="bg-gray-900 border mt-3 px-3">						
						<div class="giveaway__row-outer-wrap" 
							 v-for="giveaway in pinndedGiveaway" 
							 :key="giveaway.giveaway_id">
							<div class="giveaway__row-inner-wrap">
								<div class="giveaway__summary">
									<div class="giveaway__heading">
										<!-- giveaway linke >> -->
										<router-link v-if="!giveaway.region.show" 
											class="giveaway__heading__name" to="">{{giveaway.game_name}}
										</router-link>
										<router-link v-else	class="giveaway__heading__name" 
											:to="`/${$store.state.meta.lang}/giveaway/${giveaway.creator}/${giveaway.game_seo}/${giveaway.giveaway_id}`">
											{{giveaway.game_name}}
										</router-link>
										<!-- << giveaway linke -->
										<span v-if="giveaway.keycode_cnt > 1" class="giveaway__heading__thin">({{giveaway.keycode_cnt}} Copies)</span>
										<span class="giveaway__heading__thin">({{giveaway.point && giveaway.point}} P)</span>
										<div class="d-flex">
											<a class="idc-brand ml-1" :href="`https://${$store.state.meta.lang}.idcgames.com/${giveaway.game_seo}`" target="_blank"></a>
										</div>										
									</div>
									<div class="giveaway__columns">
										<div class="d-flex justify-content-center align-items-center">
											<font-awesome-icon :icon="['fa','clock']" class="mr-1" /> 
											<span>{{ giveaway && giveaway.end_date | localTime | formatDate(1) }}</span> {{ $t('gifts_remaining') }}
										</div>
										<div class="giveaway__columns__width-fill text-right">
											<span>{{giveaway.start_date | localTime | formatDate }}</span> {{ $t('gifts_ago') }} {{ $t('gifts_by') }}
											<router-link 
												:to="`/${$store.state.meta.lang}/user/${giveaway.creator}`" 
												class="giveaway__username">
												{{giveaway.creator}}
											</router-link>
										</div>
										<!-- Region >> -->																				
										<div v-if="!giveaway.region.show" class="giveaway__columns__region">
											<font-awesome-icon :icon="['fa','globe']" class="d-block text-dark" 
												style="height: 26px; cursor: pointer;" 
												title="" /> 
										</div>
										<!-- CB Level >> -->
										<div v-if="giveaway.contribute_level > 0" class="giveaway__columns__contributor-level"> 
											{{ $t('gifts_level') }} {{ giveaway.contribute_level }} 
										</div>
									</div>
									<div class="giveaway__links">										
										<!-- >> entries -->
										<router-link v-if="giveaway.region.show" :to="`/${$store.state.meta.lang}/giveaways/entries/${giveaway.giveaway_id}`">
											<font-awesome-icon :icon="['fa','tag']" /> 
											<span class="mx-1">{{giveaway.entries_cnt}}</span>{{ $t('gifts_entries') }}
										</router-link>
										<router-link v-else to="">
											<font-awesome-icon :icon="['fa','tag']" /> 
											<span class="mx-1">{{giveaway.entries_cnt}}</span>{{ $t('gifts_entries') }}
										</router-link>
										<!-- >> comments -->
										<router-link v-if="giveaway.region.show" :to="`/${$store.state.meta.lang}/giveaway/${giveaway.creator}/${giveaway.game_seo}/${giveaway.giveaway_id}`">
											<font-awesome-icon :icon="['fa','comment']" /> 
											<span class="mx-1">{{giveaway.comments_cnt}}</span>{{ $t('gifts_comments') }}
										</router-link>
										<router-link v-else to="">
											<font-awesome-icon :icon="['fa','comment']" /> 
											<span class="mx-1">{{giveaway.comments_cnt}}</span>{{ $t('gifts_comments') }}
										</router-link>
									</div>
								</div>
								<router-link 
									:to="`/${$store.state.meta.lang}/user/${giveaway.creator}`" 
									class="giveaway_image_avatar" 
									:style="giveaway.profile_photo_path ? 
										{ 'background-image': 'url(' + apiDomain + '/uploads/avatar/' + giveaway.profile_photo_path + ')' }:
										{ 'background-image': 'url(' + missed_avatar + ')' }"
								>
								</router-link>

								<!-- >> -->
								<div class="d-flex flex-row flex-wrap mx-0">
									<div class="game-card-rectangular" >
										<router-link v-if="!giveaway.region.show" to="" class="giveaway_image_thumbnail">
											<div class="d-flex flex-row">
												<div class="d-flex align-items-center justify-content-center position-relative">
													<div class="position-relative">
														<div class="overlay">
															<img class="logo-overlay card-img-overlay m-auto giveaway_image_thumbnail" :src="giveaway.game_logo"  alt="--">
														</div>
														<div class="bg-img-container overflow-hidden box-shadow giveaway_image_thumbnail">
															<img class="gameCard-img" :src="giveaway.game_banner" alt="...">
														</div>
													</div>
												</div>												
											</div>  													
										</router-link>
										<router-link v-else :to="`/${$store.state.meta.lang}/giveaway/${giveaway.creator}/${giveaway.game_seo}/${giveaway.giveaway_id}`" class="giveaway_image_thumbnail">
											<div class="d-flex flex-row">
												<div class="d-flex align-items-center justify-content-center position-relative">
													<div class="position-relative">
														<div class="overlay">
															<img class="logo-overlay card-img-overlay m-auto giveaway_image_thumbnail" :src="giveaway.game_logo"  alt="--">
														</div>
														<div class="bg-img-container overflow-hidden box-shadow giveaway_image_thumbnail">
															<img class="gameCard-img" :src="giveaway.game_banner" alt="...">
														</div>
													</div>
												</div>												
											</div>  													
										</router-link>
									</div>
								</div>
								<!-- << -->
							</div>
						</div>
					</div>
					<h2 class="border-bottom border-green-lighter my-3"> Giveaways </h2>
					<!-- giveway list -->
					<div class="bg-gray-900 border border-green-lighter mt-3 px-3">
						<div class="giveaway__row-outer-wrap" 							 
							 v-for="giveaway in allGiveaways"
							 :key="giveaway.id">
							<div class="giveaway__row-inner-wrap">
								<div class="giveaway__summary">
									<div class="giveaway__heading">										
										<!-- giveaway link >> -->
										<router-link v-if="!giveaway.region.show" 
											class="giveaway__heading__name" to="">{{giveaway.game_name}}
										</router-link>
										<router-link v-else	class="giveaway__heading__name" :to="`/${$store.state.meta.lang}/giveaway/${giveaway.creator}/${giveaway.game_seo}/${giveaway.giveaway_id}`">
											{{giveaway.game_name}}
										</router-link>
										<!-- << giveaway link -->
										<span v-if="giveaway.keycode_cnt > 1" class="giveaway__heading__thin">({{giveaway.keycode_cnt}} Copies)</span>
										<span class="giveaway__heading__thin">({{ giveaway && giveaway.point}} P)</span>
										<div class="d-flex">
											<a class="idc-brand ml-1" :href="`https://${$store.state.meta.lang}.idcgames.com/${giveaway.game_seo}`" target="_blank"></a>
										</div>										
									</div>
									<div class="giveaway__columns">
										<div class="d-flex justify-content-center align-items-center">
											<font-awesome-icon :icon="['fa','clock']" class="mr-1"/> 
											<span>{{ giveaway && giveaway.end_date | localTime | formatDate(1) }}</span> {{ $t('gifts_remaining') }}
										</div>
										<div class="giveaway__columns__width-fill text-right">
											<span>{{ giveaway && giveaway.start_date | localTime | formatDate}}</span> {{ $t('gifts_ago') }} {{ $t('gifts_by') }} 
											<a 	class="giveaway__username" 
												:href="`/${$store.state.meta.lang}/user/${giveaway.creator}`">
												{{giveaway.creator}}
											</a>
										</div>
										<!-- Region >> -->																				
										<div v-if="!giveaway.region.show" class="giveaway__columns__region">
											<font-awesome-icon :icon="['fa','globe']" class="d-block text-dark" 
												style="height: 26px; cursor: pointer;" title="Region Restricted"/> 
										</div>
										<div v-if="giveaway.contribute_level > 0" class="giveaway__columns__contributor-level"> {{ $t('gifts_level') }} {{ giveaway.contribute_level }}</div>
									</div>
									<div class="giveaway__links">
										<!-- >> entries -->
										<router-link v-if="giveaway.region.show" :to="`/${$store.state.meta.lang}/giveaways/entries/${giveaway.giveaway_id}`">
											<font-awesome-icon :icon="['fa','tag']" /> 
											<span class="mx-1">{{giveaway.entries_cnt}}</span>{{ $t('gifts_entries') }}
										</router-link>
										<router-link v-else to="">
											<font-awesome-icon :icon="['fa','tag']" /> 
											<span class="mx-1">{{giveaway.entries_cnt}}</span>{{ $t('gifts_entries') }}
										</router-link>
										<!-- >> comments -->
										<router-link v-if="giveaway.region.show" :to="`/${$store.state.meta.lang}/giveaway/${giveaway.creator}/${giveaway.game_seo}/${giveaway.giveaway_id}`">
											<font-awesome-icon :icon="['fa','comment']" /> 
											<span class="mx-1">{{giveaway.comments_cnt}}</span>{{ $t('gifts_comments') }}
										</router-link>
										<router-link v-else to="">
											<font-awesome-icon :icon="['fa','comment']" /> 
											<span class="mx-1">{{giveaway.comments_cnt}}</span>{{ $t('gifts_comments') }}
										</router-link>
									</div>
								</div>
								<router-link 
									:to="`/${$store.state.meta.lang}/user/${giveaway.creator}`" 
									class="giveaway_image_avatar"
									:style="giveaway.profile_photo_path ? 
									{ 'background-image': 'url(' + apiDomain+'/uploads/avatar/'+ giveaway.profile_photo_path + ')' } : 
									{ 'background-image': 'url(' + missed_avatar + ')' }"
								>
								</router-link>
								
								<div class="d-flex flex-row flex-wrap mx-0">
									<div class="game-card-rectangular" >
										<router-link v-if="!giveaway.region.show" to="" class="giveaway_image_thumbnail">
											<div class="d-flex flex-row">
												<div class="d-flex align-items-center justify-content-center position-relative">
													<div class="position-relative">
														<div class="overlay">
															<img class="logo-overlay card-img-overlay m-auto giveaway_image_thumbnail" :src="giveaway.game_logo"  alt="--">
														</div>
														<div class="bg-img-container overflow-hidden box-shadow giveaway_image_thumbnail">
															<img class="gameCard-img" :src="giveaway.game_banner" alt="...">
														</div>
													</div>
												</div>												
											</div>  													
										</router-link>
										<router-link v-else :to="`/${$store.state.meta.lang}/giveaway/${giveaway.creator}/${giveaway.game_seo}/${giveaway.giveaway_id}`" class="giveaway_image_thumbnail">
											<div class="d-flex flex-row">
												<div class="d-flex align-items-center justify-content-center position-relative">
													<div class="position-relative">
														<div class="overlay">
															<img class="logo-overlay card-img-overlay m-auto giveaway_image_thumbnail" :src="giveaway.game_logo"  alt="--">
														</div>
														<div class="bg-img-container overflow-hidden box-shadow giveaway_image_thumbnail">
															<img class="gameCard-img" :src="giveaway.game_banner" alt="...">
														</div>
													</div>
												</div>												
											</div>  													
										</router-link>
									</div>
								</div>
							</div>
						</div>
					</div>					
					<div class="bg-gray-900 border border-green-lighter mt-3 px-3 py-3">
						<div class="row">
							<!-- 10 top deal list -->
							<div class="col-lg-6 col-md-12">
								<h2 class="border-bottom border-green-lighter mt-3"> {{ $t('gifts_deals') }} </h2>
								<div class="giveaway__row-outer-wrap" v-for="deal in drawDeals" :key="deal.discussion_id">
									<div class="giveaway__row-inner-wrap">
										<router-link 
											:to="`/${$store.state.meta.lang}/user/${deal.creator}`" 
											class="giveaway_image_avatar" 
											:style="deal.profile_photo_path ? 
											{ 'background-image': 'url(' + apiDomain+'/uploads/avatar/'+ deal.profile_photo_path + ')' } : 
											{ 'background-image': 'url(' + missed_avatar + ')' }"
										>
										</router-link>										
										<div>
											<div>
												<router-link :to="`/${$store.state.meta.lang}/discussion_detail/${deal.title}/${deal.discussion_id}`">
													{{deal.title}}
												</router-link>
											</div>
											<small>
												<router-link :to="`/${$store.state.meta.lang}/discussion_detail/${deal.title}/${deal.discussion_id}`">
													{{deal.comment_cnt ? deal.comment_cnt : 0}} {{ $t('gifts_comments') }} 
												</router-link>
												<span v-if="deal.comment_cnt">
													{{ $t('gifts_last_post') }} 
													{{deal.last_comment_date | localTime | formatDate}} {{ $t('gifts_ago') }} {{ $t('gifts_by') }} 
													<router-link :to="`/${$store.state.meta.lang}/user/${deal.creator}`">{{deal.creator}} 					<font-awesome-icon :icon="['fa','chevron-circle-right']" />
													</router-link>
												</span>
											</small>
										</div>
									</div>
								</div>
							</div>
							<!-- 10 top discussion list -->
							<div class="col-lg-6 col-md-12">
								<h2 class="border-bottom border-green-lighter mt-3"> {{ $t('gifts_discussions') }}</h2>
								<div class="giveaway__row-outer-wrap" v-for="(discussion, key) in drawDiscussions" :key="key">
									<div class="giveaway__row-inner-wrap">
										<router-link 
											:to="`/${$store.state.meta.lang}/user/${discussion.creator}`"
											class="giveaway_image_avatar" 
											:style="discussion.profile_photo_path ? 
											{ 'background-image': 'url(' + apiDomain + '/uploads/avatar/' + discussion.profile_photo_path + ')' }:
											{ 'background-image': 'url(' + missed_avatar + ')' }"
										>
										</router-link>
										<div>
											<div>
												<router-link :to="`/${$store.state.meta.lang}/discussion_detail/${discussion.title}/${discussion.discussion_id}`">
													{{discussion.title}}
												</router-link>
											</div>
											<small>
												<router-link :to="`/${$store.state.meta.lang}/discussion_detail/${discussion.title}/${discussion.discussion_id}`">
													{{discussion.comment_cnt ? discussion.comment_cnt : 0}} {{ $t('gifts_comments') }} 
												</router-link>
												<span v-if="discussion.comment_cnt">
													{{ $t('gifts_last_post') }} 
													{{discussion.last_comment_date | localTime | formatDate}} {{ $t('gifts_ago') }} {{ $t('gifts_by') }} 
													<router-link :to="`/${$store.state.meta.lang}/user/${discussion.creator}`">
														{{discussion.creator}}
														<font-awesome-icon :icon="['fa','chevron-circle-right']" />
													</router-link>
												</span>
											</small>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import FancyInput from '../FancyInput'
	import InfoTooltip from '../InfoTooltip.vue'
	import {apiDomain} from '../../config'
	import ThreadDisplayPlaceholder from '../ThreadDisplayPlaceholder'
	import NotificationForm from '../NotificationForm.vue';

	export default {
		name: 'landing',
		components: {
			FancyInput,
			InfoTooltip,
			ThreadDisplayPlaceholder,
			NotificationForm
		},
		data () {
			return {
				apiDomain: apiDomain,
				hero_img: require("./../../assets/img/new-home/header.jpg"),
				choosed_color: "#00ff7f",
				choosed_back_color: "#00ff7f",
				loading: true,				
				categories: [
					{ "name": `${this.$t('gifts_all')}`, "value": "all"},
					{ "name": `${this.$t('gifts_recommended')}`, "value": "recommended"}, 
					{ "name": `${this.$t('gifts_multiple_copies')}`, "value": "multi"},
					{ "name": "DLC", "value": "dlc"},
					{ "name": `${this.$t('gifts_new')}`, "value": "new"},
					{ "name": `${this.$t('gifts_whislist')}`, "value": "wishlist"}
				],
				searchGiveaway: "",
				orgGiveaways: [],
				allGiveaways: this.$store.state.meta.giveaways,
				// pinndedGiveaway: this.$store.state.meta.giveaways.slice(0, 2),
				pinndedGiveaway: [],
				orgPinndedGiveaway: [],
				errors: {
					content: '',
					name: '',
					pollQuestion: '',
					pollAnswer: '',
					search: '',
				},
				missed_avatar: require("./../../assets/img/new-home/missed_avatar.jpg"),
				drawDeals: [],
				drawDiscussions: []
			}
		},
		created(){
			// this.$toast.error(message, {duration: 1000});

			//Discussion
			this.axios.request({
				method: 'GET',
				url: `${apiDomain}/api/v1/discussions/all`,
				data: {},
				headers: {
					'Authorization': `Bearer ${this.$cookies.get('authtoken')}`
				}
			}).then(res => {				
				this.waitLoading = false;
				this.$store.commit('setDiscussions', res.data);
				this.drawDiscussions = res.data;

				let deals = this.$t('gifts_deals').toLowerCase(); //
				this.drawDeals = this.drawDiscussions.filter( x => x.category.toLowerCase() === 'deals' );

			}).catch(err => {				
				this.waitLoading = false;						
				console.log(err)
			})

			function getRandomInt(max) {
				return Math.floor(Math.random() * max);
			}

			//all givesaways
			this.axios.request({
			method: 'GET',
			url: `${apiDomain}/api/v1/giveaways/all`
			}).then(res => {
				
				this.loading = false;
				let oo = this; let data = [];

				if(!!this.$store.state.username){

					this.orgGiveaways = res.data.data.giveaways.all.filter( x => (x.region.show == true) && (x.contribute_level*1 <= oo.$store.state.level) );

					this.orgPinndedGiveaway = res.data.data.giveaways.featured.filter( x => (x.region.show == true) && (x.contribute_level*1 <= oo.$store.state.level) );

					data = this.orgGiveaways;

				}else{

					this.orgGiveaways = res.data.data.giveaways.all.filter( x => x.region.show == true );

					this.orgPinndedGiveaway = res.data.data.giveaways.featured.filter( x => x.region.show );

					data = this.orgGiveaways;
				}				

				this.$store.commit('setGiveaways', data);
				
				let nLen = getRandomInt(this.orgGiveaways.length || 0);
				this.$store.commit('setMainGiveaways', (this.orgGiveaways[nLen] || null) );

				//
				(this.$route.query.type === 'wishlist') && this.filterGiveaway('wishlist');
				(this.$route.query.type === 'multi') && this.filterGiveaway('multi');
				(this.$route.query.type === 'new') && this.filterGiveaway('new');

			}).catch(err => {						
				this.$store.commit('setGiveaways', []);
				this.$store.commit('setMainGiveaways', {});
			})
		},
		watch: {
			searchGiveaway: function(skey){

				this.pinndedGiveaway = this.orgPinndedGiveaway.filter( x=>x.game_name.toLowerCase().includes(skey.toLowerCase()) ).slice(0, 2)

				this.allGiveaways = this.$store.state.meta.giveaways.filter( x=>x.game_name.toLowerCase().includes(skey.toLowerCase()) )

				!this.allGiveaways.length ? (this.errors.search = this.$t("gifts_no_results")) : this.errors.search = '';				
			},
			'$store.state.meta.giveaways': function() {

				this.allGiveaways = this.$store.state.meta.giveaways;
				this.pinndedGiveaway = this.orgPinndedGiveaway.slice(0, 2);
			},
			'$route.query.type': function(val){

				this.filterGiveaway(val);
			}
		},	
		methods: {
			filterGiveaway: function(Type){

				if(Type=='wishlist' && this.$store.state.username){
					
					this.loading = true;
					let oo = this;
					this.axios.post(`${apiDomain}/api/v1/userwishlist`, 
						{token: this.$cookies.get('token')}
					).then(res => {
						
						this.loading = false;

						let wishlists = res.data.data.map( x => { return x.id_idcgame } );
						let ggs = oo.orgGiveaways.filter( x => wishlists.includes(x.idc_game_id*1) );
	
						let data = !!oo.$store.state.username ? ggs.filter(x => x.contribute_level*1 <= oo.$store.state.level) : ggs;
							
						this.$store.commit('setGiveaways', data);
						
						let nLen = Math.floor( Math.random() * (ggs.length || 0) );

						!ggs.length ? this.$store.commit('setMainGiveaways', oo.orgGiveaways[0] ) 
										 : this.$store.commit('setMainGiveaways', ggs[nLen] );
	
					}).catch(err => {						
						this.$store.commit('setGiveaways', []);
						this.$store.commit('setMainGiveaways', {});
					})

				}else if(Type=='multi'){

					let mtGiveaways = this.orgGiveaways.filter( x => x.keycode_cnt > 1);

					this.$store.commit('setGiveaways', mtGiveaways);
						
					var nLen = Math.floor( Math.random() * (this.orgGiveaways.length || 0));

					this.$store.commit('setMainGiveaways', this.orgGiveaways[nLen] )

				}else if(Type=='new'){

					try{

						let here = this
						let newGiveaways = this.orgGiveaways.filter( x =>  
							{
								let lTime = here.$options.filters.localTime(x.start_date);
								let dTime = here.$options.filters.differTimeHour(lTime).nums;
								if( dTime <= 8 ){
									return x;
								}
							}
						);
						
						this.$store.commit('setGiveaways', newGiveaways);
							
						var nLen = Math.floor( Math.random() * (this.orgGiveaways.length || 0) );
						this.$store.commit('setMainGiveaways', this.orgGiveaways[nLen] )

					}catch(err){
						console.log(err);
					}


				}else{
					
					try{
						this.$store.commit('setGiveaways', this.orgGiveaways);
							
						var nLen = Math.floor( Math.random() * (this.orgGiveaways.length || 0) );
	
						this.$store.commit('setMainGiveaways', this.orgGiveaways[nLen] )

					}catch(err){
						console.log(err);
					}
				}

			}
		}	
	}
</script>

<style lang='scss' scoped>
	@import '../../assets/scss/elementStyles.scss';
	@import '../../assets/scss/variables.scss';
	@import '../../assets/scss/idec.scss';

	.hero_section{
		display: flex;
		justify-content: center; 
		align-items: center;

		@at-root #{&}__img_link {
			margin-right: 25px;
			background-color: rgba(0,0,0,0.2);
			border-left-color: transparent;
			border-top-color: transparent;
			box-shadow: 3px 3px 4px #0000002e;
			padding: 10px;

			img{
				width: 100%;
				max-width: 500px;
				max-height: 215px;
			}
		}

		@at-root #{&}__summary {
			flex: 1;

			.summary_columns{
				display: flex;

				.summary__column{
					min-height: 26px;
					white-space: nowrap;
					color: rgba(255,255,255,0.6);
					border-radius: 4px;
					font-size: 11px;
					border: 1px solid rgba(255,255,255,0.1);
					line-height: 26px;
					padding: 0 8px;

					&:nth-child(2){
						flex: 1;
						margin-left: 0.5rem;
						margin-right: 0.5rem;
					}
				}
			}
		}
	}

	.router-link-exact-active span:first-child {
		background-color: $color__green--primary;
	}

	.router-link-exact-active span:last-child {
		color: $color__green--primary;
	}

	.giveaway__row-outer-wrap {
		padding: 15px 0;

		&:not(:last-child){
			border-bottom: 1px solid #d2d6e0;
		}

		.giveaway__row-inner-wrap{
			display: flex;
			align-items: center;

			.giveaway__summary{
				flex: 1;
				margin-right: 1rem;

				.giveaway__heading{
					display: flex;
					align-items: center;
					height: 25px;
					white-space: nowrap;

					&__name{
						font-size: 20px;
					}

					&__thin{
						margin-left: 5px;
						letter-spacing: 1px;
						font-weight: 300;
						font-size: 20px;
					}

					.giveaway__icon{
						margin-left: 0.5rem;
						opacity: .35;
						cursor: pointer;
					}
				}

				.giveaway__columns{
					display: flex;
					align-items: center;
					margin: 0.5rem 0;

					&__width-fill{
						flex: 1;
					}

					&__contributor-level{
						border-color: #f0d0d3 #e5bbbc #daa9a8 #ebbfc0 !important;
    					color: rgba(166,93,92,0.95) !important;
						background-image: -webkit-linear-gradient(#f5eaec 0%, #e6d9de 100%) !important;
					}

					&__region{
						border-color: #f0d0d3 #e5bbbc #daa9a8 #ebbfc0 !important;
    					color: rgba(194, 190, 190, 0.95) !important;
						background-image: -webkit-linear-gradient(#f5eaec 0%, #e6d9de 100%) !important;
					}

					&>*{
						white-space: nowrap;
						border-radius: 4px;
						font-size: 11px;
						border: 1px solid #d2d6e0;
						line-height: 26px;
						padding: 0 8px;
					}

					&>*:not(:last-child){
						margin-right: 5px;
					}
				}

				.giveaway__links{
					height: 25px;
    				display: flex;
					align-items: center;

					a{
						margin-right: 15px;
					}
				}
			}
		}
	}

	.threads_main {
		display: flex;

		&__side_bar{
			width: 12rem;
			height: 0%;
			background: #fff;
			margin-right: 1rem;
			border-radius: 0.25rem;
			border: thin solid $color__gray--darker;
			padding: 0.5rem 0 1rem 1rem;
			position: sticky;
			top: 4.5rem;

			@at-root #{&}__title {
				color: $color__darkgray--darker;
				cursor: default;
				font-weight: 500;
				font-size: 1.125rem;
			}

			@at-root #{&}__menu_item {
				cursor: pointer;
				margin-top: 0.5rem;
				position: relative;
				display: grid;
				grid-template-columns: 0.75rem auto;
				grid-column-gap: 1rem;
				text-decoration: none;
				background-image: none;
				font-weight: normal;
				margin-left: 1.5rem;

				span{
					color: #fff;
				}

				@at-root #{&}__border {
					align-self: center;
					display: inline-block;
					height: 0.9rem;
					width: 0.9rem;
					border-radius: 0.5rem;
					margin-top: 0;
					background-color: $color__gray--darkest;
					transition: all 0.2s;
				}

				@at-root #{&}__text {
					filter: saturate(0.75), brightness(0.75);
				}


				@at-root #{&}--selected {
					font-weight: 600;
				}
			}
		}

		&__load_new{
			@extend .button;

			font-size: 1.25rem;
			margin: 0 0 1rem 0;
			background-color: $color__lightgray--primary;
			border-color: $color__gray--darker;
			width: 100%;
			font-weight: 300;
		}
	}

	@media (max-width: $breakpoint--tablet) {
		.hero_section{
			display: block;
			text-align: center;
		}
		.giveaway__row-outer-wrap {
			overflow-x: auto;

			.giveaway__row-inner-wrap{
				min-width: 600px;
			}
		}
	}
</style>
<style>
.img-container-init{
	min-width: 430px;
	min-height: 215px;
}

.idc-brand {
	/* background-image: url("https://cdn.idcgames.net/img/default/logo-idc-dark.png"); */
	background-image: url("https://cdn.idcgames.net/img/default/logo-idc-light.png");
	height: 25px;
	width: 25px;
	background-position: center;
	background-size: contain;
	background-repeat: no-repeat;    
}
</style>
